import { PatternPuzzleState } from "@shared/types/PatternPuzzleState";
import { css, html } from "../helpers/webComponents";
import PatternPuzzleService from "../services/PatternPuzzleService";
import { GameEventService } from "../services/GameEventService";
import { Page } from "../enums/Page";

const styles: string = css`
    :host {
        height: 480px;
        width: 480px;
        background-image: url("/assets/img/puzzles/pattern_background.png");
        position: relative;
    }

    .keystone {
        width: 180px;
        height: 180px;
        border-radius: 1000px;
        border: 0;
        background-size: cover;
        display: block;
        position: absolute;
    }

    #keystone-left { 
        background-image: url("/assets/img/puzzles/keystone_left.png");
        bottom: 45px;
        left: 45px;
    }

    #keystone-middle {
        background-image: url("/assets/img/puzzles/keystone_middle.png");
        top: 45px;
        left: 150px;
    }

    #keystone-right {
        background-image: url("/assets/img/puzzles//keystone_right.png");
        bottom: 45px;
        right: 45px;
    }
`;

export default class PatternPuzzleComponent extends HTMLElement {
    private _patternPuzzleService: PatternPuzzleService = new PatternPuzzleService();
    private _gameEventService: GameEventService = new GameEventService();

    /** The constructor of the component */
    public connectedCallback(): void {
        // Attach the shadow root to the component for scoped styling
        this.attachShadow({ mode: "open" });
        // Refresh the component state
        void this.refreshState();
    }

    private async refreshState(): Promise<void> {
        const state: PatternPuzzleState = await this._patternPuzzleService.getState();
        this.render(state);
    }

    private render(state: PatternPuzzleState): void {
        // Don't render if the shadow root isn't set
        if (!this.shadowRoot) return;
        // Construct the html element
        const element: HTMLElement = this.construct(state);
        // Refresh the body of the shadow root
        this.shadowRoot.replaceChildren(element);
    }

    private construct(state: PatternPuzzleState): HTMLElement {
        const element: HTMLElement = html`
            <div>
                <style>${styles}</style>
                <button style="rotate: ${state.keyAngles[0]}deg" class="keystone" id="keystone-left"></button>
                <button style="rotate: ${state.keyAngles[1]}deg" class="keystone" id="keystone-middle"></button>
                <button style="rotate: ${state.keyAngles[2]}deg" class="keystone" id="keystone-right"></button>
            </div>
        `;
        // Add the events to the keystone buttons
        element.querySelectorAll(".keystone").forEach((button, index) => {
            button.addEventListener("click", async () => {
                // Rotate the puzzle piece using the service
                const state: PatternPuzzleState = await this._patternPuzzleService.rotate(index);
                // Switch the player back to the room if the puzzle is solved
                if (state.solved) this._gameEventService.switchPage(Page.Canvas);
                // Re-render the component using the new state
                else this.render(state);
            });
        });
        return element;
    }
}
